import { AppShell, Title } from '@mantine/core';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { useBreakpoint } from 'shared/lib';
import { dashboardPageModel } from '../../model';
import { DashboardChart } from '../dashboard-chart';
import { DashboardFilter } from '../dashboard-filter';
import { DashboardNoDashboard } from '../dashboard-no-dashboard';
import { DashboardSidebar } from '../dashboard-sidebar';
import cls from './dashboard-page.module.scss';

export const DashboardPage = () => {
	const { t } = useTranslation();

	const md = useBreakpoint('md');

	const selectedMetrics = useUnit(dashboardPageModel.$selectedMetrics);

	return (
		<AppShell.Main className={cls.dashboardPage}>
			<Title
				order={1}
				size={md ? 'h1' : 'h3'}
				className={cls.dashboardPageTitle}
			>
				{t('dashboard-page.title')}
			</Title>
			<div className={cls.dashboardPageContent}>
				<DashboardSidebar />
				<div className={cls.dashboardPageMain}>
					<div className={cls.dashboardPageMainBox}>
						<DashboardFilter />
						{selectedMetrics.length === 0 ? <DashboardNoDashboard /> : <DashboardChart />}
					</div>
				</div>
			</div>
		</AppShell.Main>
	);
};
